import { createSlice } from '@reduxjs/toolkit';
import { deleteTenant } from './deleteTenantAction';

export const deleteTenantSlice = createSlice({
  name: 'deleteTenantDetail',
  initialState: {
    loading: false,
    message: '',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    // login slice
    builder.addCase(deleteTenant.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteTenant.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.message = payload.message;
      state.error = null;
    });
    builder.addCase(deleteTenant.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || 'An error occurred';
    });
  },
});
